import { useQuery } from '@tanstack/react-query';

import type { Asset } from '@cognite/sdk';

import { useFDMServices } from '../../../../providers/fdm-services/fdm-services.context';
import { QueryKeys } from '../../../../utils/queryKeys';

export const useRootAssetList = ({ enabled }: { enabled: boolean }) => {
  const { assetService } = useFDMServices();

  return useQuery<Asset[]>({
    queryKey: [QueryKeys.ASSET, 'root list'],
    queryFn: async () => {
      return assetService.getRootAssets();
    },
    meta: { error: { captureError: true } },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled,
  });
};
